// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grapploct: PokeData = {
  "id": 853,
  "name": "grapploct",
  "height": 16,
  "weight": 390,
  "base_experience": 168,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bind",
    "leer",
    "submission",
    "reversal",
    "octazooka",
    "detect",
    "rock-smash",
    "taunt",
    "superpower",
    "brick-break",
    "bulk-up",
    "feint",
    "topsy-turvy",
    "octolock"
  ],
  "moves": [
    "leer",
    "rock-smash",
    "superpower",
    "bulk-up",
    "karate-chop",
    "double-kick",
    "meteor-assault",
    "coaching",
    "drain-punch",
    "rolling-kick",
    "close-combat",
    "jump-kick",
    "vacuum-wave"
  ],
  "evolution_chain": {
    "id": 448,
    "item": null,
    "species": [
      {
        "name": "clobbopus",
        "order": 852,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grapploct",
        "order": 853,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 852,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "taunt"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 69,
    "ability_power": 195
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
